<template>
  <div class="admin-projects-list-root">
    <el-row style="margin: 20px 0">
      <el-col :span="12">
        <router-link
          :to="{
            name: 'AdminProjects',
            query: { project: currentProjectId, action: 'new' },
          }"
        >
          <el-button type="primary" size="large">+ 创建新项目</el-button>
        </router-link>
      </el-col>

      <el-col :span="12" style="text-align: right">
        <el-input
          size="large"
          clearable
          v-model="filterTerm"
          placeholder="请输入项目名称进行筛选"
          style="width: 240px; text-transform: uppercase"
        >
          <template #suffix>
            <i class="iconfont icon-sousuo"></i>
          </template>
        </el-input>
      </el-col>
    </el-row>

    <TakoPanel
      :header="false"
      style="margin-bottom: 20px; padding-bottom: 20px"
    >
      <el-table :data="projects" style="width: 100%">
        <template v-for="col in cols" :key="col.prop">
          <el-table-column
            v-if="col.format"
            :width="col.width"
            :label="col.name"
            :prop="col.prop"
            :show-overflow-tooltip="false"
          >
            <template #default="scope">
              <div v-html="col.format(scope.row)"></div>
            </template>
          </el-table-column>

          <el-table-column
            v-else
            :width="col.width"
            :label="col.name"
            :prop="col.prop"
            :sortable="col.sortable || false"
          ></el-table-column>
        </template>
        <el-table-column width="200">
          <template #default="scope">
            <el-button
              plain
              type="primary"
              @click="handleCertificate(scope.row)"
              >证书管理
            </el-button>
            <el-button plain type="primary" @click="handelEdit(scope.row)"
              >编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        :total="page.total"
        :size="page.size"
        :onPageChange="handleChangePage"
        style="margin-right: 12px"
      />
    </TakoPanel>
    <div>
      <Edit ref="editRef" />
      <Certificate ref="certificateRef" />
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { reactive, ref, watch } from "vue";
import { useProjectStore } from "@/Store/ProjectStore";
import { formatList, formatDateTime, searchString } from "@/Utils/UtilTools";
import TakoPanel from "@/Components/TakoPanel.vue";
import Pagination from "@/Components/Pagination.vue";
import Edit from "./List/Edit.vue";
import Certificate from "./List/Certificate.vue";

const projectStore = useProjectStore();
const { projectList, currentProjectId } = storeToRefs(projectStore);

const cols = [
  { name: "项目名称", prop: "name" },
  { name: "项目ID", prop: "id" },
  { name: "所在地域", prop: "region" },
  { name: "包名", prop: "packagename" },
  { name: "制作人", prop: "producer" },
  { name: "主程", prop: "programer" },
  { name: "接入负责人", prop: "personincharge" },
  {
    name: "管理员",
    prop: "admins",
    format(row) {
      return formatList(row.admins, "", "<br>");
    },
  },
  {
    name: "创建时间",
    prop: "firstcreated",
    format(row) {
      return formatDateTime(row.firstcreated);
    },
  },
  {
    name: "最后上传时间",
    prop: "lastmodified",
    format(row) {
      return formatDateTime(row.lastmodified);
    },
  },
  {
    name: "打包服务",
    prop: "packing",
    format(row) {
      if (row.packing == "true") {
        return "是";
      } else {
        return "否";
      }
    },
  },
  { name: "备注", prop: "remark" },
];

const filterTerm = ref("");
const page = reactive({
  size: 10,
  total: 0,
  current: 0,
});
const projects = ref([]);
watch(
  [projectList, () => page.current, filterTerm],
  () => {
    const list = projectList.value.filter(
      (p) => !filterTerm.value || searchString(filterTerm.value, p.name)
    );
    page.total = list.length;

    projects.value = list.slice(
      page.current * page.size,
      (page.current + 1) * page.size
    );
  },
  {
    immediate: true,
  }
);

const certificateRef = ref(null);
function handleCertificate(row) {
  certificateRef.value.initData(row.id);
}

const editRef = ref(null);
function handelEdit(row) {
  const rowData = {
    id: row.id,
    inputProjectName: row.name,
    inputRegion: row.region,
    inputPackageName: row.packagename,
    inputPacking: row.packing == "true" ? true : false,
    inputRemark: row.remark,
    inputProducer: row.producer,
    inputProgramer: row.programer, //主程
    inputPersonInCharge: row.personincharge, //负责人
    inputAdmin: row.admins || [],
  };
  editRef.value.initData(rowData);
}

function handleChangePage(p) {
  page.current = p - 1;
}
</script>

<style lang="scss" scoped>
.admin-projects-list-root {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  overflow: auto;

  & :deep() .el-dialog__body {
    padding: 0px 0px 0px 10px;
  }
}
</style>
